import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { richiediUscita } from "@/components/UnsavedBar";

const NOMI = {
  "/oggi": "Home", "/task": "Task", "/attivita": "Attività", "/notizie": "Notizie", "/pipeline": "Pipeline", "/immobili": "Immobili",
  "/acquirenti": "Acquirenti", "/proprietari": "Venditori", "/visite": "Visite", "/proposte": "Proposte", "/preliminari": "Preliminari",
  "/rogiti": "Rogiti", "/documenti-scadenza": "Documenti in scadenza", "/finanza-agente": "Le mie provvigioni", "/provvigioni-team": "Provvigioni team",
  "/agenda": "Agenda", "/documenti": "Documenti", "/classifica": "Classifica", "/albo-oro": "Albo d'oro", "/da-approvare": "Da approvare",
  "/direzione-provvigioni": "Provvigioni", "/profilo": "Profilo", "/sessioni": "Sessioni", "/pulizia-dati": "Pulizia dati di prova",
  "/qualita-portafoglio": "Qualità portafoglio", "/coda-checklist": "Coda checklist", "/documentazione-in-corso": "Documentazione in corso",
  "/pronti-pubblicazione": "Pronti per pubblicazione", "/appuntamenti-oggi": "Appuntamenti di oggi", "/finanza": "Finanza Aziendale",
  "/utenti": "Utenti & Team", "/ticket": "Ticket", "/storico": "Storico", "/privacy": "Privacy", "/guardiana": "Guardiana",
};
const MADRE = { notizie: "/notizie", immobili: "/immobili", proprietari: "/proprietari", acquirenti: "/acquirenti", ticket: "/ticket" };
const K = "nav_stack_v1";
const S = "nav_scroll_v1";

const SCHEDA = { notizie: "Notizia", immobili: "Immobile", proprietari: "Venditore", acquirenti: "Acquirente", ticket: "Ticket" };
const nomeDi = (path) => {
  const p = path.split("?")[0];
  if (NOMI[p]) return NOMI[p];
  const seg = p.split("/")[1];
  return SCHEDA[seg] || NOMI[`/${seg}`] || "Indietro";
};
const leggi = (k, d) => { try { return JSON.parse(sessionStorage.getItem(k)) ?? d; } catch { return d; } };

export default function BackBar() {
  const loc = useLocation();
  const nav = useNavigate();
  const tipo = useNavigationType();
  const here = loc.pathname + loc.search;
  const stackRef = useRef(leggi(K, []));
  const [, setTick] = useState(0);

  useEffect(() => {
    const st = stackRef.current;
    if (tipo === "POP" && st[st.length - 2] === here) st.pop();
    else if (tipo === "REPLACE" && st.length) st[st.length - 1] = here;
    else if (st[st.length - 1] !== here) st.push(here);
    stackRef.current = st.slice(-50);
    sessionStorage.setItem(K, JSON.stringify(stackRef.current));
    setTick((n) => n + 1);
    if (tipo === "POP") {
      const y = leggi(S, {})[here];
      if (y) [80, 300, 700, 1200, 2000].forEach((ms) => setTimeout(() => { if (Math.abs(window.scrollY - y) > 40) window.scrollTo(0, y); }, ms));
    }
  }, [here, tipo]);

  useEffect(() => {
    let t;
    const onScroll = () => { clearTimeout(t); t = setTimeout(() => { const m = leggi(S, {}); m[here] = window.scrollY; sessionStorage.setItem(S, JSON.stringify(m)); }, 150); };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => { window.removeEventListener("scroll", onScroll); clearTimeout(t); };
  }, [here]);

  if (loc.pathname === "/oggi" || loc.pathname === "/") return null;
  const st = stackRef.current;
  const prev = st.length > 1 && st[st.length - 1] === here ? st[st.length - 2] : null;
  const seg = loc.pathname.split("/")[1];
  const madre = loc.pathname.split("/").length > 2 && MADRE[seg] ? MADRE[seg] : "/oggi";
  const dest = prev || madre;
  const vai = () => richiediUscita(() => (prev ? nav(window.history.state?.__guard ? -2 : -1) : nav(madre)));
  return (
    <button data-testid="global-back-btn" onClick={vai} title={`Torna a ${nomeDi(dest)}`}
            className="flex items-center gap-1.5 min-w-0 max-w-[45vw] sm:max-w-xs px-2.5 py-1.5 rounded-lg text-sm font-medium text-slate-600 hover:text-[#111111] hover:bg-slate-100 transition-colors">
      <ArrowLeft size={16} className="shrink-0" />
      <span className="truncate" data-testid="global-back-label">{nomeDi(dest)}</span>
    </button>
  );
}
